import { useState } from 'react';

interface UseMultiStepFormProps {
  steps: number;
  initialStep?: number;
}

/**
 * Custom hook to manage multi-step form navigation
 */
export function useMultiStepForm({ steps, initialStep = 1 }: UseMultiStepFormProps) {
  const [currentStep, setCurrentStep] = useState(initialStep);
  
  const goToNextStep = () => {
    setCurrentStep((prev) => {
      return prev >= steps ? prev : prev + 1;
    });
  };
  
  const goToPreviousStep = () => {
    setCurrentStep((prev) => {
      return prev <= 1 ? prev : prev - 1;
    });
  };
  
  const goToStep = (step: number) => {
    setCurrentStep(Math.max(1, Math.min(steps, step)));
  };
  
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === steps;
  const progress = (currentStep / steps) * 100;
  
  return {
    currentStep,
    goToNextStep,
    goToPreviousStep,
    goToStep,
    isFirstStep,
    isLastStep,
    progress,
    steps,
  };
}
